/*
  Aquamarise: whole-card quick view for the product-page recommendation rows. 2026-09-29 (Claude).

  Clicking anywhere on a card in "Other rings you'll love" (sections/sg-product-row.liquid) or "Recently viewed"
  (sections/sg-recently-viewed.liquid) opens the theme's own quick-view modal for that product, the way
  abercrombie.com's product cards do. Cards opt in with data-aq-quick-view and keep their real links, so
  cmd / ctrl / shift / middle clicks, right-click "open in new tab", no-JS visitors and crawlers still get the
  product page.

  How it opens the theme's modal: theme.min.js keeps its event bus private and dispatches no DOM events on this
  store (window.flu.states is never set), so the only way in is an element the theme bound itself.
  snippets/quick-view-modal.liquid renders a hidden "featured-collection-grid" section that holds a
  [data-quick-shop-trigger="quick-view"] button; the theme's da() binds it at load and reads its
  data-product-url AT CLICK TIME. This script writes the card's product URL into that button and clicks it. The
  theme then fetches <product url>?view=quick-view, mounts its Product class (ring sizes, engraving, add to
  cart, thumbnails), opens the modal, traps focus, locks scroll, and returns focus to the card link on close.
  If the proxy is not bound (theme JS not loaded yet, or failed), a click on a link navigates as usual and a
  click on a non-link part of a card navigates to the same product page.

  Also here, because the fetched modal markup cannot carry scripts (innerHTML drops them):
    - the second click of a double-click would land on the modal wash the theme has just shown and close it,
      so wash clicks are swallowed for 600 ms after an open;
    - the theme rewrites the page URL (history.replaceState ...variant=) when a variant changes inside the
      modal, which would leave a foreign variant id on the product page the shopper is on; the URL is restored
      when the modal loses its "active" class;
    - thumbnail strip a11y: aria-current and a roving tabindex follow the theme's own "active" class, the
      strip scrolls the active thumbnail into view, and ArrowLeft / ArrowRight move between thumbnails;
    - phone photo carousel (all media items side by side under 720px): the dots follow the swipe, and when
      the theme switches the featured image for a variant the carousel scrolls to it;
    - "View full details" carries the variant chosen in the modal (?variant=) to the product page;
    - html.aq-qv-ready is set once the proxy is confirmed bound, so the cards only show a pointer cursor on
      their non-link areas when a click there will do something.
  The card links carry class "no-transition" (theme page-transition delegate opt-out), so the handler only
  needs preventDefault and never stops propagation (analytics click listeners keep working).
*/
(function () {
  'use strict';
  if (window.__aqQuickViewCards) return;
  window.__aqQuickViewCards = true;

  var PROXY_SECTION = '[data-section-id="aq-quick-view-proxy"]';
  var PROXY_BUTTON = PROXY_SECTION + ' [data-aq-qv-proxy]';
  var MODAL = '[data-quick-view-modal]';
  var savedHref = null;
  var seenActive = false;
  var openedAt = 0;

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(sel) : el.msMatchesSelector(sel)) return el;
      el = el.parentNode;
    }
    return null;
  }
  function modal() { return document.querySelector(MODAL); }
  function proxyBound() {
    /* instances.push happens only after the section's onLoad ran without throwing, and onLoad stores the
       da() binder as productItem only when it found the .product-item and bound the trigger. */
    var section = document.querySelector(PROXY_SECTION);
    var th = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
    var list = th && th.instances;
    if (!section || !list || !list.length) return false;
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].container === section) return !!list[i].productItem;
    }
    return false;
  }
  function markReady() {
    if (!proxyBound()) return false;
    document.documentElement.classList.add('aq-qv-ready');
    return true;
  }
  function openQuickView(url) {
    var btn = document.querySelector(PROXY_BUTTON);
    var m = modal();
    if (!btn || !m || !m.querySelector('.quick-view-modal__content') || !proxyBound()) return false;
    var wasOpen = m.classList.contains('is-fixed');
    btn.setAttribute('data-product-url', url);
    btn.click();
    /* the theme adds is-fixed (and the body overlay flag) synchronously while opening, so this proves the modal reacted */
    return wasOpen || m.classList.contains('is-fixed') || document.body.getAttribute('data-fluorescent-overlay-open') === 'true';
  }
  function restoreHref() {
    if (savedHref && window.location.href !== savedHref) { try { history.replaceState(null, '', savedHref); } catch (err) {} }
    savedHref = null;
    seenActive = false;
  }

  /* ------------------------------------------------------------------ card clicks */
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (openedAt && Date.now() - openedAt < 600 && closest(e.target, MODAL + ' .modal__wash')) {
      e.preventDefault(); e.stopPropagation(); /* second click of a double-click on the card: keep the modal */
      return;
    }
    if (e.defaultPrevented) return;
    var card = closest(e.target, '[data-aq-quick-view]');
    if (!card) return;
    if (closest(e.target, 'button, input, select, textarea, label, [data-aq-qv-ignore]')) return;
    var link = card.tagName === 'A' ? card : card.querySelector('a[href*="/products/"]');
    if (!link || link.host !== window.location.host || link.pathname.indexOf('/products/') === -1) return;
    var url = link.pathname + link.search; /* no #hash: the theme appends ?view=quick-view by string concatenation */
    var href = window.location.href;
    if (!openQuickView(url)) {
      /* proxy not bound (yet): a link click navigates by itself; a click on the card's dots / price still goes to the product */
      if (!closest(e.target, 'a')) { e.preventDefault(); window.location.href = link.href; }
      return;
    }
    markReady();
    savedHref = href;
    seenActive = false;
    openedAt = Date.now();
    e.preventDefault();
  }, true);

  /* ------------------------------------------------------------------ "View full details" keeps the chosen variant */
  document.addEventListener('click', function (e) {
    var a = closest(e.target, '[data-aq-qv-details]');
    if (!a) return;
    var form = closest(a, 'form');
    var sel = form && form.querySelector('[data-variant-select]');
    if (sel && sel.value && sel.options && sel.options.length > 1) a.search = '?variant=' + sel.value;
  });

  /* ------------------------------------------------------------------ thumbnails: arrow keys */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var t = closest(e.target, '.aq-qv-thumbs [data-product-thumbnail]');
    if (!t) return;
    var all = t.parentNode.querySelectorAll('[data-product-thumbnail]');
    var i = Array.prototype.indexOf.call(all, t);
    var n = all[(i + (e.key === 'ArrowRight' ? 1 : -1) + all.length) % all.length];
    if (n && n !== t) { e.preventDefault(); n.focus(); n.click(); }
  });

  /* ------------------------------------------------------------------ modal observers */
  function syncThumbs(root) {
    var thumbs = root.querySelectorAll('.aq-qv-thumbs [data-product-thumbnail]');
    for (var i = 0; i < thumbs.length; i++) {
      var on = thumbs[i].classList.contains('active');
      if (on) thumbs[i].setAttribute('aria-current', 'true'); else thumbs[i].removeAttribute('aria-current');
      thumbs[i].setAttribute('tabindex', on ? '0' : '-1');
      if (on) {
        /* one scrolling row: keep the active thumbnail in view */
        var strip = thumbs[i].parentNode;
        var left = thumbs[i].offsetLeft - strip.offsetLeft;
        var w = thumbs[i].offsetWidth;
        if (strip.scrollWidth > strip.clientWidth && (left < strip.scrollLeft || left + w > strip.scrollLeft + strip.clientWidth)) {
          strip.scrollTo({ left: Math.max(0, left - (strip.clientWidth - w) / 2), behavior: 'smooth' });
        }
      }
    }
  }
  var carouselLast = null;
  function syncCarousel(root) {
    var media = root.querySelector('.quick-product--left .product__media');
    if (!media) { carouselLast = null; return; }
    var items = media.querySelectorAll('[data-product-media-wrapper]');
    var dots = root.querySelectorAll('.aq-qv-dots span');
    var setDot = function (i) { for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('active', k === i); };
    var first = !media.__aqCarousel;
    if (first) {
      media.__aqCarousel = true;
      carouselLast = null;
      var tick = 0;
      media.addEventListener('scroll', function () {
        if (tick) return;
        tick = setTimeout(function () { tick = 0; if (media.clientWidth) setDot(Math.round(media.scrollLeft / media.clientWidth)); }, 40);
      }, { passive: true });
    }
    if (items.length < 2 || media.scrollWidth <= media.clientWidth + 1) return; /* not the phone carousel */
    var visible = -1;
    for (var i = 0; i < items.length; i++) if (!items[i].classList.contains('hidden')) { visible = i; break; }
    if (visible < 0) return;
    var id = items[visible].getAttribute('data-media-item-id');
    if (id === carouselLast) return; /* the theme switched the featured image (variant change) only when this changes */
    carouselLast = id;
    media.scrollTo({ left: visible * media.clientWidth, behavior: first ? 'auto' : 'smooth' });
    setDot(visible);
  }
  function watchModal() {
    var m = modal();
    if (!m || !window.MutationObserver) return;
    var t = 0;
    new MutationObserver(function () {
      var active = m.classList.contains('active');
      if (active) seenActive = true;
      else if (savedHref && seenActive) restoreHref();
      clearTimeout(t); t = setTimeout(function () { syncThumbs(m); syncCarousel(m); }, 30);
    }).observe(m, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  watchModal();
  if (!markReady()) {
    document.addEventListener('DOMContentLoaded', markReady);
    window.addEventListener('load', markReady);
  }
})();